import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import moment from 'moment';

import type {
  CleanReservationLimitDayResult,
  CleanReservationRuleResponse,
  MonthReservationLimit,
  ReservationRuleFormValues,
} from '../sharedTypes';

dayjs.extend(duration);
dayjs.extend(weekOfYear);

export const days = ['週日', '週一', '週二', '週三', '週四', '週五', '週六'];

export const getCleanKindRulesFormValues = (
  data: CleanReservationRuleResponse
) => {
  const {
    _id,
    mustCancelBefore,
    canReserveAfter,
    canReserveBefore,
    autoPushNotification,
  } = data;
  const rules: ReservationRuleFormValues = {
    _id,
    mustCancelBeforeNumber: mustCancelBefore.value,
    mustCancelBeforeUnit: mustCancelBefore.unit,
    canReserveAfterNumber: canReserveAfter.value,
    canReserveAfterUnit: canReserveAfter.unit,
    canReserveBeforeNumber: canReserveBefore.value,
    canReserveBeforeUnit: canReserveBefore.unit,
    autoPushNotification: moment(autoPushNotification).utc(),
  };

  return rules;
};

export const getMonthLimitList = (
  limits: CleanReservationLimitDayResult[],
  kindNames: { cleanKindId: string; name: string }[]
) => {
  const monthData: MonthReservationLimit[][] = [];
  let weekData: MonthReservationLimit[] = [];
  const lastDayOfMonth = dayjs(limits[0].date).endOf('month').date();
  let weekCount = 1;

  limits.forEach((data) => {
    let dayCount = dayjs(data.date).day();
    if (dayCount < 7) {
      const newResult = data.result.map((limit) => {
        return {
          ...limit,
          cleanKindName: kindNames.find(
            (kind) => kind.cleanKindId === limit.cleanKindId
          )?.name,
        };
      });
      const newDailyLimit = {
        ...data,
        result: newResult,
      };
      weekData.push(newDailyLimit);
      dayCount++;
    }

    if (dayCount === 7 || dayjs(data.date).date() === lastDayOfMonth) {
      monthData.push(weekData);
    }

    if (dayCount === 7) {
      weekData = [];
      weekCount = weekCount + 1;
    }
  });
  return monthData;
};
